import { Row, Col, Form } from "react-bootstrap";

const PatientForResumeRow = ({name, id}) => {
  return (
    <Row>
      <Col md={12} className="">
        <div className="patient-card rounded shadow mb-4 p-3 w-100 ">
          <Row>
            <Col md={3} className="text-center">
              <img src="https://via.placeholder.com/100" alt="img" className="img-fluid rounded-circle" />
            </Col>
            <Col md={7}>
              <h6>ID: {id}</h6>
              <p className="mb-0">{name}</p>
            </Col>

            <Col md={2} className="text-end">
              <Form.Check type="radio" />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default PatientForResumeRow;
